import { render, staticRenderFns } from "./SrWorkOrderList.vue?vue&type=template&id=2d620ad7&"
import script from "./SrWorkOrderList.vue?vue&type=script&lang=js&"
export * from "./SrWorkOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports